<template>
    <div class="homeinterativa">
        <PageTitle icon="fas fa-battery-three-quarters iconInterativoTitulo" main="Baterias Inteligentes Hion"
            sub="Monitore sua Bateria em Tempo Real" />
        

        <!-- Portfolio Gallery Grid -->
        <div class="paiPortifolioDashboard">
            <div class="rowDashboard">
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartSOC />
                    </div>
                </div>
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartStatus />
                    </div>
                </div>
            </div>
            <div class="contentDashboard" v-if="usuario.admin">
                <chartTensao />
            </div>

            <div class="rowDashboard">
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartTemp />
                    </div>
                </div>
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartAutonomia />
                    </div>
                </div>
            </div>
            <div class="contentDashboard" v-if="usuario.admin">
                <chartCorrente />
            </div>

            <div class="rowDashboard">
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartConexao />
                    </div>
                </div>
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartTempoRecarga />
                    </div>
                </div>
            </div>

            <div class="rowDashboard" v-if="usuario.admin">
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartAcorda />
                    </div>
                </div>
                <div class="columnDashboard">
                    <div class="contentDashboard">
                        <chartDTC />
                    </div>
                </div>
            </div>

        </div>
        <!-- Final Portifolio Dashboard -->

        <div class="CorrecaoBottomPage"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import PageTitle from '../PageTitle'
import chartTensao from '../charts/chartTensao'
import chartSOC from '../charts/chartSOC'
import chartStatus from '../charts/chartStatus'
import chartTemp from '../charts/chartTemp'
import chartAutonomia from '../charts/chartAutonomia'
import chartCorrente from '../charts/chartCorrente'
import chartConexao from '../charts/chartConexao'
import chartTempoRecarga from '../charts/chartTempoRecarga'
import chartAcorda from '../charts/chartAcorda'
import chartDTC from '../charts/chartDTC'

export default {
    name: 'BateriaInterativa',
    components: { PageTitle, chartTensao, chartSOC,
                    chartStatus, chartAutonomia, chartTemp,
                    chartCorrente, chartConexao, chartDTC,
                    chartTempoRecarga, chartAcorda
                },
    computed: mapState(['usuario'])
}
</script>

<style>

/* CSS DO PORTIFOLIO ***/
.paiPortifolioDashboard {
    position: relative;
    width: 95%;
    margin:auto;
}
.rowDashboard {
  margin: 8px -16px;
}
.rowDashboard,
.rowDashboard > .columnDashboard {
  padding: 8px;
}
.columnDashboard {
  float: left;
  width: 50%;
}
.rowDashboard:after {
  content: "";
  display: table;
  clear: both;
}
.contentDashboard {
    background-color: #2e2d2c;
    padding: 1.5%;
    box-shadow: 5px 5px 10px #2e2d2cee;
    border-radius: 10px;
    position: relative;
}
.contentDashboard:hover {
    transform: scale(1.02);
    transition: .5s ease;
    cursor: pointer;
}
.contentDashboard:hover .overlayLabel {
    opacity: 1;
}
.contentDashboard em {
    color: #fff;
}

/*** CHARTS ***********/

.CorrecaoBottomPage {
    display: inline-block;
    padding: 80px;
}


/* MEDIA QUERY MD *********************************************************/
@media (min-width: 768px) and (max-width:991px) { /* MD */

.columnDashboard {
    width: 100%;
}

}


/* MEDIA QUERY SM *************************************************************/
@media (min-width: 576px) and (max-width:767px) { /* SM */

.columnDashboard {
    width: 100%;
}

}


/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */

.columnDashboard {
    width: 100%;
}

}

</style>